import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import NonconformityForm from "../Components/Nonconformity/NonconformityForm";
import * as orderActions from '../Actions/orderActions';
import { orderService } from "../Services/OrderService.js";
//import UserForm from "../Components/User/UserForm";
//import { userService } from "../Services/UserService.js";
//import { languageService } from "../Services/LanguageService.js";

class NonconformityFormContainer extends Component {
	constructor(props) {
		super(props);
		//this.state={
		//	langPairs: []
		//};
		this.saveNonconformity = this.saveNonconformity.bind(this);
	}
	
	componentDidMount() {
		
	}
	
	saveNonconformity(nonconformity, closeIsue){
		if((typeof this.props.nonconformityOrder.nonconformity !== 'undefined') && (this.props.nonconformityOrder.nonconformity !== null) ){
			let nc=this.props.nonconformityOrder.nonconformity;
			nc.description=nonconformity.description;
			nc.title=nonconformity.title;
			nc.correctiveAction=nonconformity.correctiveAction;
			if(closeIsue){
				nc.correctionDate = new Date();
			}
			orderService.updateNonconformity(nc)
				.then(response => {return this.props.history.go(-1);})
				.catch(err => {/*console.log(err);*/});
		}else{
			let nc={
				title:nonconformity.title,
				description:nonconformity.description,
				correctiveAction:""
			}
			orderService.createNonconformity(this.props.nonconformityOrder.id, nc)
				.then(response => {return this.props.history.go(-1);})
				.catch(err => {/*console.log(err);*/});
		}
	}
	
	render() {
		var id, description, title, correctiveAction;
		if((typeof this.props.nonconformityOrder.nonconformity !== 'undefined') && (this.props.nonconformityOrder.nonconformity !== null) ){
			id=this.props.nonconformityOrder.nonconformity.id;
			description=this.props.nonconformityOrder.nonconformity.description;
			title=this.props.nonconformityOrder.nonconformity.title;
			correctiveAction=this.props.nonconformityOrder.nonconformity.correctiveAction;
		}else{
			id=0;
			description="";
			title="";
			correctiveAction="";
		}
	    return (<NonconformityForm	orderId={this.props.nonconformityOrder.id}
									id={id}
									description={description}
									title={title}
									correctiveAction={correctiveAction}
									saveNonconformity={this.saveNonconformity}
									role={this.props.role}/>);
	}
}

function mapStateToProps(state, ownProps) {  
	return {
		//nonconformityOrder: state.orders.find(idOrder => {if(idOrder.id == ownProps.match.params.idOrder){ return true;}}),
		nonconformityOrder: state.orders[ownProps.match.params.idOrder],
		role: state.user.role
	}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(orderActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(NonconformityFormContainer);  